export default __webpack_public_path__ + "static/2130-7b956d3cfb328b1b493aa7ca8f6aabd0.gif";